module.exports = "<svg width=\"19\" height=\"16\" viewBox=\"0 0 19 16\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"currentColor\" d=\"M7.789 2.284c1.17-1.872 3.068-1.87 4.237 0l6.358 10.172c1.17 1.872.33 3.39-1.88 3.39H3.311c-2.208 0-3.049-1.52-1.88-3.39L7.79 2.284z\"></path><path fill=\"#000\" d=\"M9 5h2v5H9zM9 11h2v2H9z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/warning-black.svg
// module id = 892
// module chunks = 0